import { WaitlistBand } from "../components/WaitlistBand";

export default function SellersPage() {
  return (
    <div data-testid="sellers-page">
      <section className="max-w-[1200px] mx-auto px-6 lg:px-12 pt-16 pb-16">
        <div className="overline text-[var(--gu-muted)] mb-4">For growers</div>
        <h1 className="font-display text-5xl lg:text-7xl font-light tracking-tighter leading-[0.95] max-w-4xl">
          Bring your leaves under the umbrella.
        </h1>
        <p className="mt-8 text-[var(--gu-muted)] max-w-2xl leading-relaxed text-lg">
          Grace Under Umbrella is opening to other small house plant growers. If you keep
          more cuttings than you can pot, hand-throw ceramics, or grow rare cultivars in
          a spare room — this will be your storefront.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12 border-y border-[var(--gu-border)]">
        <Step n="01" title="Apply" body="Join the seller waitlist. We're inviting growers in small waves as the marketplace opens." />
        <Step n="02" title="Set up shop" body="Upload your plants, tell their story, set your prices. We handle the storefront." />
        <Step n="03" title="Grow" body="Ship directly to buyers. Keep 90% of every sale. We only take a slim cut for the shelter." />
      </section>

      <WaitlistBand />
    </div>
  );
}

function Step({ n, title, body }) {
  return (
    <div>
      <div className="overline text-[var(--gu-accent)] mb-4">{n}</div>
      <div className="font-display text-3xl mb-4">{title}</div>
      <p className="text-[var(--gu-muted)] leading-relaxed">{body}</p>
    </div>
  );
}
